var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8327 9.99996C18.8327 14.6023 15.1017 18.3333 10.4993 18.3333C5.89698 18.3333 2.16602 14.6023 2.16602 9.99996C2.16602 5.39759 5.89698 1.66663 10.4993 1.66663C15.1017 1.66663 18.8327 5.39759 18.8327 9.99996ZM10.4993 17.0754C14.407 17.0754 17.5748 13.9076 17.5748 9.99996C17.5748 6.09228 14.407 2.92449 10.4993 2.92449C6.59167 2.92449 3.42388 6.09228 3.42388 9.99996C3.42388 13.9076 6.59167 17.0754 10.4993 17.0754Z",
    fill: "#D86700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87109 4.89981C9.87109 4.55246 10.1527 4.27087 10.5 4.27087C10.8474 4.27087 11.129 4.55246 11.129 4.8998V9.67578C11.129 9.72289 11.1477 9.76807 11.181 9.80138L13.625 12.2454C13.8706 12.491 13.8706 12.8893 13.625 13.1349C13.3794 13.3805 12.9812 13.3805 12.7356 13.1349L9.92964 10.3289C9.89215 10.2914 9.87109 10.2406 9.87109 10.1876V4.89981Z",
    fill: "#D86700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.3fbef99d504bd61669d38b46601ac80f.svg";
export { ForwardRef as ReactComponent };